module.exports = __webpack_public_path__ + "static/media/Linkedin.5e13a97e.jpg";